export default __webpack_public_path__ + "static/media/copy.bf2ddbc3.svg";